/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import { useToast } from '../../../components/Toats'
import { LoadingSpan } from '../../../components/Loadings/loadingSpan'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { StepModal } from './components/stepModal'
import { postClient, updateClient } from '../../../../services/clientService'
import { formatTelephone, formatCellphone } from '../../../../utils/formats'
import styles from '../../../unit-consumer/components/ModalAddEditUnitConsumer/modalUnitConsumer.module.css'

type DataForm = {
  email: string | null,
  nameResponsible: string | null,
  cellphone: string | null,
  cpfResponsible: string | null,
  telephone: string | null,
  instagram: string | null,
  image: string | null,
  idUser: string | null,
  idUnitBranch: string | null,
  idsPlants: string[] | []
}

type Props = {
    id?: string;
    data?: DataForm & {user?: any};
    show: boolean
    handleClose: () => void
    /** Chamado após cadastro/edição bem-sucedidos no servidor, antes de fechar o modal. */
    onSuccess?: (result?: unknown) => void
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required("Informe um e-mail. "),
  nameResponsible: Yup.string().required("Informe um nome para a filial"),
  cellphone: Yup.string(),
  cpfResponsible: Yup.string(),
  telephone: Yup.string(),
  instagram: Yup.string().nullable(),
  image: Yup.string().nullable(),
  idUser: Yup.string(),
  idUnitBranch: Yup.string(),
  idsPlants: Yup.array()
  .of(Yup.string())
  .notRequired()
  .default([]),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddUpdateClient = ({show, handleClose, data, id, onSuccess}: Props) => {
  const { toggleToast } = useToast();

  const [initialValues, setInitialValues] = useState<DataForm>({
    email: null,
    nameResponsible:  null,
    cellphone:  null,
    cpfResponsible:  null,
    telephone:  null,
    instagram: null,
    image: null,
    idUser:  null,
    idUnitBranch: null,
    idsPlants: []
  })
  const [hasError, setHasError] = useState(false)
  const [loading, setLoading] = useState(false)

  const updateData = (fieldsToUpdate: any) => {
    const updatedData = {...initialValues, ...fieldsToUpdate}
    setInitialValues(updatedData)
  }

  const checkInputs = (): boolean => {
    if (!formik.values.nameResponsible 
        || !formik.values.cpfResponsible 
        || !formik.values.email 
        || !formik.values.idUnitBranch) {
      return false
    }
    return true
  }

  const closed = () => {
    formik.setValues(initialValues)
    handleClose()
  }

  const postClientSubmit = async () => {
    try {
      setLoading(true)
      const myData = {
        email: formik.values.email,
        nameResponsible: formik.values.nameResponsible,
        cellphone: formik.values.cellphone,
        cpfResponsible: formik.values.cpfResponsible,
        telephone: formik.values.telephone,
        instagram: formik.values.instagram || null,
        image: formik.values.image,
        idUser: formik.values.idUser,
        idUnitBranch: formik.values.idUnitBranch,
        idsPlants: formik.values.idsPlants
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null && prop !== 'image') {
          delete myData[prop];
        }
      });
      const result = await postClient(myData)
      toggleToast("Sucesso ao cadastrar o cliente. ", "success")
      onSuccess?.(result)
      closed()
    } catch (error) {
      console.log('erro',error)
      toggleToast("Erro ao cadastrar o cliente. ", "error")
    } finally {
      setLoading(false)
    }
  }

  const updateClientSubmit = async (id: string) => {
    try {
      setLoading(true)
      const myData = {
        email: formik.values.email,
        nameResponsible: formik.values.nameResponsible,
        cellphone: formik.values.cellphone,
        cpfResponsible: formik.values.cpfResponsible,
        telephone: formik.values.telephone,
        // enviado mesmo vazio ('') para permitir remover o Instagram do cadastro
        instagram: formik.values.instagram ?? '',
        image: formik.values.image,
        idUser: formik.values.idUser,
        idUnitBranch: formik.values.idUnitBranch,
        idsPlants: formik.values.idsPlants
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null && prop !== 'image') {
          delete myData[prop];
        }
      });
      const result = await updateClient(myData, id)
      toggleToast("Sucesso ao atualizar o cliente. ", "success")
      onSuccess?.(result)
      closed()
    } catch (error) {
      console.log('erro',error)
      toggleToast("Erro ao atualizar o cliente. ", "error")
    } finally {
      setLoading(false)
    }
  }

  const submit = () => {
    if(id){
      updateClientSubmit(id)
    }else{
      postClientSubmit()
    }
  }

  const nextStep = () => {
    setHasError(false)
    if (!checkInputs()) {
    setHasError(true)
    return
    }
    submit()
    
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  });


  useEffect(() => {
    if(data){
      const myObject = {
        email: data.email ? data.email :  null,
        nameResponsible: data.nameResponsible ? data.nameResponsible : null,
        cellphone: data.cellphone ? formatCellphone(data.cellphone) : null,
        cpfResponsible: data.cpfResponsible ? data.cpfResponsible : null,
        telephone: data.telephone ? formatTelephone(data.telephone) : null,
        instagram: data.instagram ? data.instagram : null,
        image: data.image ? data.image : null,
        idUser: data.idUser ? data.idUser : null,
        idUnitBranch: data.idUnitBranch ? data.idUnitBranch : null,
        idsPlants: data.idsPlants ? data.idsPlants : []
      }
      formik.setValues(myObject)
    }else{
      formik.setValues(initialValues)
    }
  }, [show])

  const missingFields = [
    !formik.values.nameResponsible && 'nome',
    !formik.values.email && 'e-mail',
    !formik.values.cpfResponsible && 'CPF/CNPJ',
    !formik.values.idUnitBranch && 'filial',
  ].filter(Boolean)

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-xl'
      fullscreen='lg-down'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header py-5'>
        <div className={styles.header}>
          <span className={styles.headerIcon}>
            <KTSVG
              path={
                id
                  ? '/media/icons/duotune/communication/com006.svg'
                  : '/media/icons/duotune/communication/com014.svg'
              }
              className='svg-icon-1 svg-icon-primary'
            />
          </span>
          <div>
            <h3 className={styles.headerTitle}>{id ? 'Editar cliente' : 'Novo cliente'}</h3>
            <span className={styles.headerSubtitle}>
              Dados de contato, filial responsável, acesso ao portal e usinas
            </span>
          </div>
        </div>

        <button
          type='button'
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={closed}
          aria-label='Fechar'
        >
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </button>
      </div>

      <div className={`modal-body ${styles.body}`}>
        <form noValidate id='kt_modal_create_app_form' onSubmit={(event) => event.preventDefault()}>
          <StepModal
            data={initialValues}
            updateData={updateData}
            hasError={hasError}
            formik={formik}
            idClient={id}
            linkedUser={data?.user}
          />
        </form>
      </div>

      <div className={`modal-footer ${styles.footer}`}>
        {hasError && missingFields.length > 0 ? (
          <span className={styles.footerError}>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-3 svg-icon-danger'
            />
            Preencha os campos obrigatórios: {missingFields.join(', ')}
          </span>
        ) : (
          <span className={styles.footerHint}>
            Campos com <span className='text-danger'>*</span> são obrigatórios
          </span>
        )}

        <div className={styles.footerActions}>
          <button type='button' className='btn btn-light' onClick={closed} disabled={loading}>
            Cancelar
          </button>
          <button type='button' className='btn btn-primary' disabled={loading} onClick={nextStep}>
            {loading ? (
              <>
                Salvando <LoadingSpan style={{marginLeft: '0.5rem'}} />
              </>
            ) : (
              <>
                <KTSVG path='/media/icons/duotune/arrows/arr085.svg' className='svg-icon-3 me-1' />
                {id ? 'Salvar alterações' : 'Cadastrar cliente'}
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateClient}
